/**
 * Read the current query string without `useSearchParams()`.
 *
 * Next.js opts an entire route out of server rendering when a client component
 * calls `useSearchParams()` outside a Suspense boundary. Every caller in this
 * app reads the query string inside an effect or an event handler — never
 * during render — so the hook buys nothing and costs the whole page its
 * server-rendered HTML.
 *
 * Safe to call during render: it returns empty params on the server.
 */
export function readSearchParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

export function readSearchParam(key: string): string | null {
  return readSearchParams().get(key);
}
